(function () {

    'use strict';

    angular.module('moment', [])
        .provider('moment', MomentProvider);

    MomentProvider.$inject = [
        '$windowProvider'
    ];
    function MomentProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.moment || {};
            }
        };
    }
})();
